import { cookieBannerRef } from "./CookieBanner";

export default function CookieSettingsButton() {
    const handleClick = () => {
        if (cookieBannerRef.current) {
            cookieBannerRef.current();
        }
    };

    return (
        <button
            onClick={handleClick}
            style={{
                position: "fixed",
                bottom: "20px",
                right: "20px",
                zIndex: 9999,
                padding: "10px 14px",
                borderRadius: "999px",
                border: "none",
                background: "#111",
                color: "#fff",
                cursor: "pointer",
                fontSize: "12px",
                opacity: 0.75,
            }}
        >
            🍪 Cookies
        </button>
    );
}